import { Link } from "react-router-dom";
import CountDown from "../Helpers/CountDown";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default function CampaignCountDown({ className, data, saleBaseUrl, promotionsThree }) {
  return (
    <div>
      <div className={`w-full lg:h-[460px] ${className || ""}`}>
        <div className="container-x mx-auto h-full">
          <div className="lg:flex xl:space-x-[30px] lg:space-x-5 items-center h-full space-y-5 lg:space-y-0">
            <div className="w-full lg:w-[630px] lg:h-full h-[430px]" data-aos="fade-right">
              {data.length > 0 ? (
                <Swiper
                  spaceBetween={10}
                  pagination={{
                    clickable: true,
                    dynamicBullets: true,
                  }}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  lazy={true}
                  modules={[Autoplay, Pagination]}
                  className="mySwiper4 h-[430px]"
                >
                  {data?.map((item, index) => {
                    const { showDays, showHours, showMinutes, showSeconds } = CountDown(item?.expiry);
                    return (
                      <SwiperSlide key={index}>
                        <div
                          key={index}
                          className={`campaign-countdown h-full w-full mb-5 lg:mb-0`}
                          style={{
                            background: `url(${saleBaseUrl + item?.image[0]?.image}`,
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                          }}
                        >
                          <Link to={`/flash-sale/${item?.id}`} state={item}>
                            <div className="w-full xl:p-12 p-5">
                              <div className="countdown-wrapper w-full flex lg:justify-between justify-evenly mb-10">
                                <div className="countdown-item">
                                  <div className="countdown-number sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] rounded-full bg-white flex justify-center items-center">
                                    <span className="font-700 sm:text-[30px] text-[14px] text-[#EB5757]">
                                      {showDays}
                                    </span>
                                  </div>
                                  <p className="sm:text-[18px] text-[12px] font-500 text-center leading-8">
                                    Days
                                  </p>
                                </div>
                                <div className="countdown-item">
                                  <div className="countdown-number sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] rounded-full bg-white flex justify-center items-center">
                                    <span className="font-700 sm:text-[30px] text-[14px] text-[#2F80ED]">
                                      {showHours}
                                    </span>
                                  </div>
                                  <p className="sm:text-[18px] text-[12px] font-500 text-center leading-8">
                                    Hours
                                  </p>
                                </div>
                                <div className="countdown-item">
                                  <div className="countdown-number sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] rounded-full bg-white flex justify-center items-center">
                                    <span className="font-700 sm:text-[30px] text-[14px] text-[#219653]">
                                      {showMinutes}
                                    </span>
                                  </div>
                                  <p className="sm:text-[18px] text-[12px] font-500 text-center leading-8">
                                    Minutes
                                  </p>
                                </div>
                                <div className="countdown-item">
                                  <div className="countdown-number sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] rounded-full bg-white flex justify-center items-center">
                                    <span className="font-700 sm:text-[30px] text-[14px] text-[#EF5DA8]">
                                      {showSeconds}
                                    </span>
                                  </div>
                                  <p className="sm:text-[18px] text-[12px] font-500 text-center leading-8">
                                    Seconds
                                  </p>
                                </div>
                              </div>
                              {/* <div className="countdown-title mb-4">
                        <h1 className="text-[44px] text-qblack font-600">
                          {item?.name}
                        </h1>
                      </div> */}
                              {/* <div className="inline-flex space-x-2 items-center border-b border-qyellow">
                                <span className="text-sm font-600 tracking-wide leading-7">
                                  Shop Now
                                </span>
                                <span>
                                  <svg
                                    width="7"
                                    height="11"
                                    viewBox="0 0 7 11"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="2.08984"
                                      y="0.636719"
                                      width="6.94219"
                                      height="1.54271"
                                      transform="rotate(45 2.08984 0.636719)"
                                      fill="#1D1D1D"
                                    />
                                    <rect
                                      x="7"
                                      y="5.54492"
                                      width="6.94219"
                                      height="1.54271"
                                      transform="rotate(135 7 5.54492)"
                                      fill="#1D1D1D"
                                    />
                                  </svg>
                                </span>
                              </div> */}
                            </div>
                          </Link>
                        </div>
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
              ) : (
                <div
                  className={`campaign-countdown h-full w-full mb-5 lg:mb-0`}
                  style={{
                    background: `url(${process.env.PUBLIC_URL}/assets/images/sale-banner.jpg`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                >

                </div>
              )}

            </div>
            <div data-aos="fade-left" className="lg:h-full w-full flex-1">
              <Swiper
                spaceBetween={10}
                pagination={{
                  clickable: true,
                  dynamicBullets: true,
                }}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                lazy={true}
                modules={[Autoplay, Pagination]}
                className="mySwiper5"
              >
                {promotionsThree?.map((promotion, index) => (
                  <SwiperSlide key={index}>
                    <a href={promotion?.url || ''} target='_blank' rel='noopener noreferrer'>
                      <img
                        src={promotion?.image}
                        alt=""
                        loading="lazy"
                      />
                    </a>
                    <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
